import { useState, useCallback } from 'react';

import useAPI from "../../../hooks/useAPI";

export const ENVIOS_FILTERS = {
  TYPE: 'type',
  STATUS: 'status',
  SEARCH: 'search'
}

const buildEnviosURL = ({ baseURL, filters, page = 1, rowsPerPage = 50 }) => {
  const query = {
    ...((filters?.[ENVIOS_FILTERS.TYPE] && filters[ENVIOS_FILTERS.TYPE] !== 'all') && {type: filters[ENVIOS_FILTERS.TYPE]}),
    ...((filters?.[ENVIOS_FILTERS.STATUS] && filters[ENVIOS_FILTERS.STATUS] !== 'all') && {status: filters[ENVIOS_FILTERS.STATUS]}),
    ...(filters?.[ENVIOS_FILTERS.SEARCH] && {search: filters[ENVIOS_FILTERS.SEARCH]}),
    page,
    limit: rowsPerPage
  }

  const urlSearchParams = new URLSearchParams(query);

  const urlQuery = urlSearchParams.size > 0 ? `?${urlSearchParams.toString()}` : '';

  return `${baseURL}${urlQuery}`;
}

export default function useEnvios() {
  const [filters, setFilters] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(0);

  const { data, isLoading, refreshData } = useAPI(buildEnviosURL({ baseURL: '/admin/envios', filters, page: page + 1, rowsPerPage }));
  
  const changePage = useCallback((page = 0) => {
    setPage(page);
  }, []);

  const changeRowsPerPage = useCallback((rowsPerPage = 50) => {
    changePage(0);
    setRowsPerPage(rowsPerPage);
  }, []);

  const changeFilters = useCallback((filters = {}) => {
    changePage(0);
    setFilters(prev => ({...prev, ...filters}));
  }, []);

  const clearFilters = useCallback(() => {
    setFilters({});
  }, []);

  return {
    data: data?.envios,
    summary: data?.resultado_count,
    total: data?.total,
    page,
    rowsPerPage,
    filters,
    isLoading,
    changePage,
    changeRowsPerPage,
    changeFilters,
    clearFilters,
    refreshData
  }
}